import React from 'react';
import {View, Toolbar, ToolbarOption, ActionButton} from 'react-template';
import $ from 'jquery'

export default class FieldTypes extends View {
    
    componentDidMount() {
        this.camposConfig()
    }

    componentWillUnmount(){
        this.removeToolbar()
    }

    camposConfig(){
        let toolbarNumero = new ToolbarOption("Número", this.addCampo.bind(this,'numero'), null, 'looks_one')
        let toolbarMonetario = new ToolbarOption("Monetário", this.addCampo.bind(this,'textocurto-dinheiro'), null, 'attach_money')
        let toolbarData = new ToolbarOption("Data", this.addCampo.bind(this,'data'), null, 'date_range')
        let toolbarLista = new ToolbarOption("Lista", this.addCampo.bind(this,'select'), null, 'arrow_drop_down')
        let toolbarMEscolha = new ToolbarOption("Múltipla escolha", this.addCampo.bind(this,'radio'), null, 'radio_button_checked')
        let toolbarCSelecao = new ToolbarOption("Caixa de seleção", this.addCampo.bind(this,'checkbox'), null, 'check_box')
        let toolbarArquivo = new ToolbarOption("Arquivo", this.addCampo.bind(this,'arquivo'), null, 'attachment')
        
        // Campos de Texto
        let toolbarCurto = new ToolbarOption("Curto", this.addCampo.bind(this,'textocurto'), null, 'drag_handle')
        let toolbarLongo = new ToolbarOption("Longo", this.addCampo.bind(this,'textolongo'), null, 'format_align_justify')
        let toolbarEmail = new ToolbarOption("E-mail", this.addCampo.bind(this,'email'), null, 'email')
        let toolbarCPF = new ToolbarOption("CPF", this.addCampo.bind(this,'textocurto-cpf'), null, 'credit_card')
        let toolbarCNPJ = new ToolbarOption("CNPJ", this.addCampo.bind(this,'textocurto-cnpj'), null, 'account_balance')
        let toolbarCEP = new ToolbarOption("CEP", this.addCampo.bind(this,'textocurto-cep'), null, 'markunread_mailbox')
        let toolbarTelefone = new ToolbarOption("Telefone", this.addCampo.bind(this,'textocurto-telefone'), null, 'phone')
        let toolbarCTexto = new ToolbarOption("Campos de Texto", null, 
            [toolbarCurto, toolbarLongo, toolbarEmail, toolbarCPF, toolbarCNPJ, toolbarCEP, toolbarTelefone], 
            'attachment')

        let toolbar = new Toolbar("Adicionar Campo")
        toolbar.addOption(toolbarCTexto)
        toolbar.addOption(toolbarNumero)
        toolbar.addOption(toolbarMonetario)
        toolbar.addOption(toolbarData)
        toolbar.addOption(toolbarLista)
        toolbar.addOption(toolbarMEscolha)
        toolbar.addOption(toolbarCSelecao)
        if (this.props.isForm) toolbar.addOption(toolbarArquivo)
        this.displayToolbar(toolbar, true)
    }

    addCampo(value) {
        let itemN = {
                tipo: value,
                pergunta: '',
                obrigatorio: false
        };
        switch (value){
            case 'radio':
                //radio tem no mínimo duas opções
                itemN = {...itemN, obrigatorio: true, opcoes: [{id: 0, texto: ''}, {id: 1, texto: ''}]};
                break;
            case 'checkbox':
                //checkbox tem no mínimo uma opções
                 itemN = {...itemN, opcoes: [{id: 0, texto: ''}]};
                break;
            case 'select':
                //select tem no mínimo uma opções
                itemN = {...itemN, opcoes: [{id: 0, texto: ''}], certificado: false};
                break;
            default:
                break;
        }

        // Função para adicionar item no reducer
        // função passada por props
        // Action: ADD_ITEM_GRU
        this.props.actions.addItem(itemN)

        // Animação de rolar a pagina ate o final 
        // quando adiciona um novo item
        // $("html, body").animate({ scrollTop: $(document).height() }, 600);
        $(".mdl-layout").animate({ scrollTop: $(".mdl-layout__content").height() }, 600);

    }

    render() {
        return (
            <div className='btn-fb-md'>
                <ActionButton label="Menu" icon="menu" onClick={() => this.openRightNav()}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/formbuilder/FieldTypes.js